import * as React from "react";
import type { SVGProps } from "react";
const SvgLink = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M12.48 16.08h.05a4.46 4.46 0 0 0 3.1-1.27l4.07-4.07a4.54 4.54 0 0 0-6.42-6.42l-.5.5a1 1 0 0 0 .325 1.639A1 1 0 0 0 14.2 6.24l.5-.5a2.53 2.53 0 0 1 3.58 0 2.51 2.51 0 0 1-.04 3.62l-4 4a2.48 2.48 0 0 1-1.75.71 2.5 2.5 0 0 1-1.76-.75 1 1 0 0 0-1.41 0 1 1 0 0 0 0 1.41 4.44 4.44 0 0 0 3.16 1.35Z"
    />
    <path
      fill="currentColor"
      d="M4.32 19.71a4.55 4.55 0 0 0 3.21 1.32 4.55 4.55 0 0 0 3.25-1.29l.5-.5a1.002 1.002 0 0 0-.325-1.639 1 1 0 0 0-1.095.219l-.5.5a2.532 2.532 0 0 1-3.58 0 2.509 2.509 0 0 1-.75-1.79 2.51 2.51 0 0 1 .79-1.78l4-4a2.48 2.48 0 0 1 1.75-.71 2.5 2.5 0 0 1 1.76.75 1 1 0 0 0 1.41 0 1 1 0 0 0 0-1.41 4.44 4.44 0 0 0-3.16-1.35 4.55 4.55 0 0 0-3.19 1.19l-4.07 4.07a4.54 4.54 0 0 0 0 6.42Z"
    />
  </svg>
);
export default SvgLink;
